import * as XLSX from "xlsx";

// Converts a value (string, number, object, or array of them) into readable
// text for a spreadsheet cell. Arrays are joined; objects are reduced to their
// most likely label field.
const toText = (value) => {
  if (value === undefined || value === null) return "";
  if (Array.isArray(value)) {
    return value.map(toText).filter((v) => v !== "").join(", ");
  }
  if (typeof value === "object") {
    return toText(
      value.title ??
        value.name ??
        value.company_name ??
        value.city ??
        value.city_name ??
        value.label ??
        value.value ??
        ""
    );
  }
  return String(value);
};

// Reads the first non-empty value for a field, checking both the record and a
// nested `basic_details` object (the admin API can return either).
const pick = (record, keys) => {
  const details = record?.basic_details ?? {};
  for (const key of keys) {
    const top = record?.[key];
    if (top !== undefined && top !== null && top !== "") return top;
    const nested = details?.[key];
    if (nested !== undefined && nested !== null && nested !== "") return nested;
  }
  return "";
};

// Maps employer (job-post) records to the Excel export columns using the real
// admin/fetch-employer-list field names, with a few alternate-key fallbacks.
export const buildEmployerRows = (employers = []) =>
  (Array.isArray(employers) ? employers : []).map((employer) => ({
    Organization: toText(pick(employer, ["Orgination", "organization", "company_name", "company"])),
    "Contact Name": toText(pick(employer, ["Contact_Name", "contact_name", "employer_name", "name"])),
    Email: toText(pick(employer, ["Email", "email", "email_id"])),
    Phone: toText(pick(employer, ["Phone", "phone", "mobile", "phone_number"])),
    "Registered Office": toText(pick(employer, ["Registred_Office", "registered_office", "address"])),
    "Job Post City": toText(pick(employer, ["Job_Post_City", "job_post_city", "city"])),
    "Job Title": toText(pick(employer, ["Job_Title", "job_title"])),
    "Job Type": toText(pick(employer, ["Job_Type", "job_type"])),
    Openings: toText(pick(employer, ["Opening", "openings", "opening"])),
    "Salary Range": toText(pick(employer, ["Salary_Range", "salary_range"])),
    "Age Range": toText(pick(employer, ["Age_Range", "age_range"])),
    "Experience Required": toText(pick(employer, ["Experince_Rerq", "experience_required", "experience_req"])),
    "Min Experience": toText(pick(employer, ["Min_Ex", "min_ex", "min_experience"])),
    "Max Experience": toText(pick(employer, ["Max_Exp", "max_exp", "max_experience"])),
    "CV Required": toText(pick(employer, ["CV_Req", "cv_req"])),
  }));

export const buildEmployerWorkbook = (employers = []) => {
  const rows = buildEmployerRows(employers);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Employers");
  return workbook;
};

export const exportEmployersToExcel = (employers = [], filename) => {
  const workbook = buildEmployerWorkbook(employers);
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, filename || `employers-${stamp}.xlsx`);
};
